import { Input, Label } from '@windmill/react-ui';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { EditableFormQuestion } from 'src/models/editableForm';
import EditableInput from 'src/components/_common/EditableInput/EditableInput';

const AdminFormQuestionOptions = ({ question, handleSetQuestionHelpText }: {question: EditableFormQuestion, handleSetQuestionHelpText: (helpText: string, questionOrder: number) => void}) => {
  const { formatMessage } = useIntl();
  const [showCommentField, toggleShowCommentField] = useState<boolean>(!!question?.helpText);

  useEffect(() => {
    if (!showCommentField)handleSetQuestionHelpText('', question?.order);
  }, [showCommentField]);

  return (
    <div className="contents">
      <Label>
        <Input
          type="checkbox"
          defaultChecked={!!question?.helpText}
          value="supervisor-text"
          onChange={() => toggleShowCommentField(!showCommentField)}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
          css=""
          crossOrigin={undefined}
        />
        <span className="text-black"><FormattedMessage id="supervisor-text" /></span>
      </Label>
      {showCommentField
        && (
        <div className="mt-4 block text-sm text-gray-700">
          <span><FormattedMessage id="edit-supervisor-text" /></span>
          <EditableInput
            text={question?.helpText}
            active
            markdownToolbar
            ariaLabel={formatMessage({ id: 'edit-supervisor-text' })}
            rows={5}
            onChangeHandler={value => handleSetQuestionHelpText(value, question?.order)}
          />
        </div>
        )}
    </div>
  );
};

export default AdminFormQuestionOptions;
